'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var errCode = require('err-code');

var ipfsUnixfs = require('ipfs-unixfs');

var findCidInShard = require('../../utils/find-cid-in-shard.js');

var dagPb = require('@ipld/dag-pb');

var file = require('./content/file.js');

var directory = require('./content/directory.js');

var hamtShardedDirectory = require('./content/hamt-sharded-directory.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var findLinkCid = function findLinkCid(node, name) {
  var link = node.Links.find(function (link) {
    return link.Name === name;
  });
  return link && link.Hash;
};

var contentExporters = {
  raw: file,
  file: file,
  directory: directory,
  'hamt-sharded-directory': hamtShardedDirectory,
  metadata: function metadata(cid, node, unixfs, path, resolve, depth, blockstore) {
    return function () {
      return [];
    };
  },
  symlink: function symlink(cid, node, unixfs, path, resolve, depth, blockstore) {
    return function () {
      return [];
    };
  }
};

var unixFsResolver = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid, name, path, toResolve, resolve, depth, blockstore, options) {
    var block, node, unixfs, next, linkCid, nextName, nextPath;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return blockstore.get(cid, options);

          case 2:
            block = _context.sent;
            node = dagPb.decode(block);

            if (!name) {
              name = cid.toString();
            }

            if (!(node.Data == null)) {
              _context.next = 7;
              break;
            }

            throw errCode__default['default'](new Error('no data in PBNode'), 'ERR_NOT_UNIXFS');

          case 7:
            _context.prev = 7;
            unixfs = ipfsUnixfs.UnixFS.unmarshal(node.Data);
            _context.next = 14;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](7);
            throw errCode__default['default'](_context.t0, 'ERR_NOT_UNIXFS');

          case 14:
            if (!path) {
              path = name;
            }

            if (!toResolve.length) {
              _context.next = 28;
              break;
            }

            if (!(unixfs && unixfs.type === 'hamt-sharded-directory')) {
              _context.next = 22;
              break;
            }

            _context.next = 19;
            return findCidInShard(node, toResolve[0], blockstore);

          case 19:
            linkCid = _context.sent;
            _context.next = 23;
            break;

          case 22:
            linkCid = findLinkCid(node, toResolve[0]);

          case 23:
            if (linkCid) {
              _context.next = 25;
              break;
            }

            throw errCode__default['default'](new Error('file does not exist'), 'ERR_NOT_FOUND');

          case 25:
            nextName = toResolve.shift();
            nextPath = "".concat(path, "/").concat(nextName);
            next = {
              cid: linkCid,
              toResolve: toResolve,
              name: nextName || '',
              path: nextPath
            };

          case 28:
            return _context.abrupt("return", {
              entry: {
                type: unixfs.isDirectory() ? 'directory' : 'file',
                name: name,
                path: path,
                cid: cid,
                content: contentExporters[unixfs.type](cid, node, unixfs, path, resolve, depth, blockstore),
                unixfs: unixfs,
                depth: depth,
                node: node,
                size: unixfs.fileSize()
              },
              next: next
            });

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[7, 11]]);
  }));

  return function unixFsResolver(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = unixFsResolver;